<template>
    <div class="inquiry-shipping-wrapper distribution">
        <div class="title">询价信息</div>
        <el-form :model="inquiryShipAO" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
            <div class="info-box">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="订单类型：">
                            <el-radio-group v-model="inquiryShipAO.orderType" @change="changeOrderType">
                                <el-radio  :label="1">抢单</el-radio>
                                <el-radio  :label="2">询价</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="价格类型：">
                            <el-radio-group v-model="inquiryShipAO.priceType" @change="changePriceType">
                                <el-radio  :label="1">单价</el-radio>
                                <el-radio  :label="2">整单价</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" v-if="inquiryShipAO.priceType === 1">
                        <el-form-item label="计价方式：">
                            <el-radio-group v-model="inquiryShipAO.valuationType" @change="calTotalAmount">
                                <el-radio  :label="1">重量</el-radio>
                                <el-radio  :label="2">体积</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="inquiryShipAO.orderType === 1">
                        <el-form-item label="单价价格：" prop="name" v-if="inquiryShipAO.priceType === 1">
                            <template slot="label"><span class="red-c">*</span>单价价格：</template>
                            <el-input v-model="amount" placeholder="请输入单价价格"   style="width: 242px;height: 30px;"
                                      oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value.slice(1);"
                                      @input="amount = amount.replace( /[^0-9.]/g, '' )"
                                      maxlength="9"
                                      @change="calTotalAmount"></el-input>
                            <span style="color: #333;margin-left: 10px">{{inquiryShipAO.valuationType === 1 ? '元/千克' : '元/立方米'}}</span>
                        </el-form-item>
                        <el-form-item label="整单价格：" prop="name" v-if="inquiryShipAO.priceType === 2">
                            <template slot="label"><span class="red-c">*</span>整单价格：</template>
                            <el-input v-model="amount" placeholder="请输入整单价格"
                                      oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value.slice(1);"
                                      @input="amount = amount.replace( /[^0-9.]/g, '' )"
                                      maxlength="9"
                                      style="width: 242px;height: 30px;" @change="calTotalAmount"></el-input>
                            <span style="color: #333;margin-left: 10px">元</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="inquiryShipAO.orderType === 2">
                        <el-form-item label="询价时间：">
                            <template slot="label"><span class="red-c">*</span>询价时间：</template>
                            <el-date-picker
                                    style="width: 360px;height: 30px;"
                                    v-model="inquiryTime"
                                    type="datetimerange"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    @change="inquiryTimeChange">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row  v-if="inquiryShipAO.orderType === 1" style="font-weight: 550">
                    <el-col :span="12">
                        <el-form-item label="计划总运费：">{{totalAmount}} 元</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="交易方式：">
                            <el-radio-group v-model="inquiryShipAO.carryType" @change="changeCarryType">
                                <el-radio  :label="1">指定承运</el-radio>
                                <el-radio  :label="2">非指定承运</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="logistics-provider-box flex-sc" v-if="inquiryShipAO.carryType === 1">
                <div class="logistics-provider-content">
                    <div class="logistics-title">物流商</div>
                    <div class="step-box flex">
                        <div v-for="(item,index) in stepData" :key="index">
                            <div class="step-content"
                                 :class="{'border-right': index === 1,  'active-item':activeIndex === index, }"
                                 @click="handleActive(index)">{{item}}
                            </div>
                        </div>
                    </div>
                    <div class="margin-t10">
                        <el-input v-model="searchData" placeholder="请输入" suffix-icon="el-icon-search"
                                  style="width: 230px;height: 30px;margin-right: 10px" :disabled="activeIndex === 1"></el-input>
                        <eui-btn type="weak" @click="selectData" :disabled="activeIndex === 1">查询</eui-btn>
                    </div>
                    <div class="transport-wrapper">
                        <el-checkbox-group v-model="orderCarrierUnitList">
                            <el-checkbox v-for="item in transport"
                                         :label="item.companyId"
                                         :key="item.companyId"
                                         class="margin-b10" style="display: block">{{item.companyName}}</el-checkbox>
                        </el-checkbox-group>
                        <div v-if="transport.length === 0" class="flex-c" style="color: #8c939d">暂无数据</div>
                    </div>
                </div>
                <eui-btn type="primary" icon="eicon-arrow-right" style="margin: 0 20px" @click="addTransport">添 加</eui-btn>
                <div class="logistics-provider-content">
                    <div class="logistics-title">已选物流商</div>
                    <div class="select-data-wrapper">
                        <div v-for="(item,index) in inquiryShipAO.orderCarrierUnitList" :key="index" class="company-name flex-sb">
                            <e-tooltip :content="item.companyName" :set-length="16"/>
                            <div @click.stop="delTransport(item.companyId,index)">
                                <eui-icon icon="eicon-close" font-size="18px" color="#333"></eui-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="title">运输要求</div>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="发货时间：">
                        <template slot="label"><span class="red-c">*</span>发货时间：</template>
                        <el-date-picker
                                style="width: 300px;"
                                v-model="inquiryShipAO.orderRequirementAO.fromTime"
                                type="date"
                                :picker-options="pickerOptions"
                                @change="changeFromTime"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="收货时间：">
                        <template slot="label"><span class="red-c">*</span>收货时间：</template>
                        <el-date-picker
                                style="width: 300px;"
                                v-model="inquiryShipAO.orderRequirementAO.receiveTime"
                                type="date"
                                :picker-options="pickerOptionsArrivalTime"
                                placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="是否紧急：">
                        <el-radio-group v-model="inquiryShipAO.orderRequirementAO.urgency">
                            <el-radio  :label="1">是</el-radio>
                            <el-radio  :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="指定车型：">
                        <el-select v-model="inquiryShipAO.orderRequirementAO.modelsWill" placeholder="请选择" style="width: 300px;">
                            <el-option
                                    v-for="item in shipInquiryCarType"
                                    :key="item.configKey"
                                    :label="item.configValue"
                                    :value="item.configKey">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注：">
                        <el-input
                                type="textarea"
                                :show-word-limit="showWordLimit"
                                maxlength="1500"
                                placeholder="请输入内容"
                                v-model="inquiryShipAO.orderRequirementAO.remarks">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <div class="title" style="margin-top: 10px">结算及发票信息</div>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="支付方式：">
                        <template slot="label"><span class="red-c">*</span>支付方式：</template>
                        <el-radio-group v-model="inquiryShipAO.orderInvoice.payType" @change="changePayType">
                            <el-radio :label="1">易派客支付</el-radio>
                            <el-radio :label="2">线下支付</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="运输发票：">
                        <el-radio-group v-model="inquiryShipAO.orderInvoice.invoiceFlag" @change="changeInvoice">
                            <el-radio   :label="0">不开票</el-radio>
                            <el-radio   :label="1">开票</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <div v-if="inquiryShipAO.orderInvoice.invoiceFlag === 1">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="发票抬头：" prop="name">
                            <template slot="label"><span class="red-c">*</span>发票抬头：</template>
                            <el-input v-model="inquiryShipAO.orderInvoice.invoiceTitle" placeholder="请输入"
                                      maxlength="255" style="width: 300px;height: 30px;"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联系电话：" prop="name">
                            <el-input v-model="inquiryShipAO.orderInvoice.telephone" placeholder="请输入"
                                      maxlength="50" style="width: 300px;height: 30px;"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="发票税号：" prop="name">
                            <template slot="label"><span class="red-c">*</span>发票税号：</template>
                            <el-input v-model="inquiryShipAO.orderInvoice.invoiceNo" placeholder="请输入"
                                      maxlength="50" style="width: 300px;height: 30px;"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="公司开户行：" prop="name">
                            <el-input v-model="inquiryShipAO.orderInvoice.bankName" placeholder="请输入"
                                      maxlength="255" style="width: 300px;height: 30px;"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="税点：" prop="name">
                            <template slot="label"><span class="red-c">*</span>税点：</template>
                            <el-select v-model="inquiryShipAO.orderInvoice.taxPoint" placeholder="请选择" style="width: 300px;">
                                <el-option
                                        v-for="item in taxPointOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="开户行账号：" prop="name">
                            <el-input v-model="inquiryShipAO.orderInvoice.bankNo" placeholder="请输入"
                                      maxlength="50"
                                      style="width: 300px;height: 30px;"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="发票项目：" prop="name">
                            <el-input v-model="inquiryShipAO.orderInvoice.invoiceProject" placeholder="请输入"
                                      maxlength="255" style="width: 300px;height: 30px;"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注：" prop="name">
                            <el-input v-model="inquiryShipAO.orderInvoice.remarks" placeholder="请输入"
                                      maxlength="255" style="width: 300px;height: 30px;"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>
<script>
  import api from '../../../api/logistics';
  import eTooltip from "../../../components/common/e-tooltip";
  export default {
    name: "inquiryShipping",
    components:{
      eTooltip
    },
    props:{
      unitvolumeAll:Number,
      unitweightAll:Number,
      province:String,
      city:String
    },
    data() {
      return {
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          },
        },
        pickerOptionsArrivalTime: {
          disabledDate: (time) => {
            const ArrivalTime = new Date(
              this.inquiryShipAO.orderRequirementAO.fromTime
            ).getTime();
            if (ArrivalTime) {
              return ArrivalTime > time.getTime();
            }
          },
        },
        taxPointOptions:[
          {value: '0.03', label: '3%'},
          {value: '0.06', label: '6%'},
          {value: '0.09', label: '9%'},
          {value: '0.11', label: '11%'},
        ],
        showWordLimit:true,
        transport:[],
        allTransport:[],
        localTransport:[],
        shipInquiryCarType:[],
        input:'',
        inquiryTime:'',
        rules: {},
        stepData: ['全部物流商', '本地物流商',],
        activeIndex: 0,
        amount:'',
        totalAmount:'',
        inquiryShipAO:{
          priceType:1,//价格类型，默认1，1单价;2整单价
          orderType:2,//订单类型,默认2，询价，1抢单；2询价
          valuationType:1,//计价方式 默认是1;1重量；2体积；3件数
          carryType:1,//交易方式，1指定承运;2非指定承运
          inquiryStarttime:'',
          inquiryEndtime:'',
          orderCarrierUnitList:[],//指定的承运商
          invoiceFlag:0,
          payType: 1,//支付方式
          orderRequirementAO:{//运输要求
            fromTime:'',//发货时间
            modelsWill:'',//指定车型
            receiveTime:'',//收货时间
            urgency:0,//是否紧急，0：不紧急，1紧急
            remarks:''
          },
          orderInvoice: {//结算及发票信息   开票才有此节点
            payType: 1,//支付方式
            invoiceFlag: 0,// 0 不开票；1开票
          }
        },
        orderInvoice:{//结算及发票信息   开票才有此节点
          invoiceTitle:'',//发票抬头
          telephone:'',//联系电话
          invoiceNo:'',//发票税号
          bankName:'',//开户行
          bankNo:'',//开户行账号
          taxPoint:'',//税点
          invoiceProject:'',//发票项目
          remarks:'',
        },
        orderCarrierUnitList:[],
        searchData:'',
      }
    },
    methods: {
      changeFromTime(){
        this.inquiryShipAO.orderRequirementAO.receiveTime = '';
      },
      selectData(){
        if(this.activeIndex === 0){
          this.selectAllTransport();
        }
      },
      addTransport(){
        this.orderCarrierUnitList.forEach(item=>{
          let transportList = this.transport.filter(transportItem=>item === transportItem.companyId);
          let carrierUnitList = this.inquiryShipAO.orderCarrierUnitList.filter(carrierItem=> item === carrierItem.companyId);
          if(transportList.length > 0 && carrierUnitList.length === 0){
             this.inquiryShipAO.orderCarrierUnitList.push({...transportList[0],carrierCode:transportList[0].companyId,carrierName:transportList[0].companyName});
          }
        })
      },
      delTransport(companyId,itemIndex){
           this.inquiryShipAO.orderCarrierUnitList.splice(itemIndex,1)
           let index = this.orderCarrierUnitList.findIndex(item=>item === companyId);
             if(index !== -1){
              this.orderCarrierUnitList.splice(index,1);
            }
      },
      //切换交易方式
      changeCarryType(val){
        this.orderCarrierUnitList = [];
        this.activeIndex = 0;
        if(val === 1){
          this.$set(this.inquiryShipAO,'orderCarrierUnitList',[]);
        }else{
          delete this.inquiryShipAO.orderCarrierUnitList;
        }
      },
      //切换 价格类型  默认1，1单价;2整单价
      changePriceType(val){
        this.calTotalAmount();
        if(val === 1){
           this.$set(this.inquiryShipAO,'valuationType',1);
        }else{
          delete this.inquiryShipAO.valuationType;
        }
      },
      //切换订单类型 1抢单；2询价 默认2
      changeOrderType(val){
        this.inquiryTime = '';
        this.amount = '';
        this.totalAmount = '';
        if(val === 1){
            this.inquiryShipAO.amount = '';//单价价格
            this.inquiryShipAO.totalAmount = '';//计划总运费
            delete this.inquiryShipAO.inquiryStarttime;
            delete this.inquiryShipAO.inquiryEndtime;
        }else{
          delete this.inquiryShipAO.amount;
          delete this.inquiryShipAO.totalAmount;
          this.inquiryShipAO.inquiryStarttime = '';
          this.inquiryShipAO.inquiryEndtime = '';
        }
      },
      //切换发票
      changeInvoice(val){
        if(val === 1){
          this.inquiryShipAO.orderInvoice = { ...this.inquiryShipAO.orderInvoice,...this.orderInvoice};
        }else{
           const keyArr = Object.keys(this.orderInvoice);
          keyArr.forEach(item=>{
            delete this.inquiryShipAO.orderInvoice[item];
          })
        }
        this.inquiryShipAO.invoiceFlag = val;
      },
      changePayType(val){
        this.inquiryShipAO.payType = val;
      },
      inquiryTimeChange(time){
        if(time.length > 0){
          this.inquiryShipAO.inquiryStarttime = time[0];
          this.inquiryShipAO.inquiryEndtime = time[1];
        }
      },
      //计算 总运费   amount 单价价格    valuationType:1,//计价方式 默认是1;1重量；2体积；
      calTotalAmount(){
        if(this.inquiryShipAO.orderType === 1){//抢单才计算
          this.inquiryShipAO.amount = this.amount;
            //总体积
            if(this.inquiryShipAO.priceType === 2){//整单价
                this.inquiryShipAO.totalAmount = this.amount;
                this.totalAmount = this.amount;
            }else{//单价
              let total = 0;
              if(this.inquiryShipAO.valuationType === 1){
                 total = Number(this.unitweightAll) * Number(this.amount)
              }else{
                 total = Number(this.unitvolumeAll) * Number(this.amount)
              }
              this.totalAmount = Number(total).toFixed(2);
              this.inquiryShipAO.totalAmount =  this.totalAmount;
            }
        }
      },
      handleActive(index) {
        this.activeIndex = index;
        this.searchData = '';

        if(index === 1){//本地
            this.getLocalTenantList();
        }else{
            this.transport = this.allTransport;
        }
      },
      //获取本地物流商
      getLocalTenantList(){
        if(!this.province || !this.city){
          this.transport = [];
          return false;
        }
        api.getLocalTenantList({fromAddr:this.province + this.city,companyName:this.searchData}).then((res) => {
          if (res.success) {
            this.transport = res.data;
          }
        });
      },
      queryShipInquiryCarType(){
        api.queryShipInquiryCarType().then((res) => {
          if (res.success) {
            this.shipInquiryCarType = res.data;
          }
        });
      },
    //校验必填字段
      verifyMandatoryData(){
        // console.log(this.inquiryShipAO.orderInvoice,'this.inquiryShipAO.orderInvoice')
        // return
         // 单价价格、整单价格
        if(this.inquiryShipAO.orderType === 1) {//抢单才计算
          if(this.inquiryShipAO.priceType === 2 && !this.amount) {//整单价
            this.$message.warning('整单价格不能为空');
            return false;
          }
          if(this.inquiryShipAO.priceType === 1 && !this.amount){
            this.$message.warning('单价价格不能为空');
            return false;
          }
        }

        if(this.inquiryShipAO.orderType === 2 && !this.inquiryShipAO.inquiryStarttime ){
          this.$message.warning('询价时间不能为空');
          return false;
        }

        if(this.inquiryShipAO.carryType === 1 && this.inquiryShipAO.orderCarrierUnitList.length === 0){
          this.$message.warning('物流商不能为空');
          return false;
        }

        if(!this.inquiryShipAO.orderRequirementAO.fromTime){
          this.$message.warning('发货时间不能为空');
          return false;
        }
        if(!this.inquiryShipAO.orderRequirementAO.receiveTime){
          this.$message.warning('收货时间不能为空');
          return false;
        }
        if(this.inquiryShipAO.orderInvoice.invoiceFlag === 1){
           if(!this.inquiryShipAO.orderInvoice.invoiceTitle){
             this.$message.warning('发票抬头不能为空');
             return false;
           }
           if(!this.inquiryShipAO.orderInvoice.invoiceNo){
             this.$message.warning('发票税号不能为空');
             return false;
           }
           if(!this.inquiryShipAO.orderInvoice.taxPoint){
             this.$message.warning('税点不能为空');
             return false;
           }
        }
        return true;
      },
      selectAllTransport(){
        api.selectAllTransport( {companyName:this.searchData}  ).then((res) => {
          if (res.success) {
            this.allTransport = res.data;
            this.transport = this.allTransport;
          }
        });
      },
    },
    watch:{
      province(){
        if(this.activeIndex === 1){
          this.getLocalTenantList();
        }
      },
      city(){
        if(this.activeIndex === 1){
          this.getLocalTenantList();
        }
      },
    },
    mounted() {
      this.selectAllTransport();
      this.queryShipInquiryCarType();
    }
  }
</script>

<style scoped lang="scss">
    .inquiry-shipping-wrapper {
        .title {
            color: #333;
            font-size: 14px;
            font-style: normal;
            font-weight: bold;
            line-height: 14px;
            padding: 20px 0;
            margin-top: 20px;
            border-top: 1px dashed #C5C5C5;
        }

        .logistics-provider-box {
            width: 100%;
            height: 464px;

            .logistics-provider-content {
                width: 360px;
                height: 464px;
                border: 1px solid #D9D9D9;
                padding: 20px 6px 20px 20px;
                 .logistics-title {
                    color: #333;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 14px;
                }

                .select-data-wrapper{
                    height: 410px;
                    overflow-y: auto;
                    margin-top: 10px;
                    color: #333;
                    font-size: 14px;
                    .company-name{
                        width: 320px;
                        height: 34px;
                        line-height: 34px;
                        cursor: pointer;
                        padding: 0 10px;
                        &:hover{
                            background-color: #F4F7FF;
                        }
                    }
                }

                .step-box {
                    margin-top: 20px;

                    .step-content {
                        width: 100px;
                        height: 40px;
                        line-height: 40px;
                        background-color: #FFF;
                        text-align: center;
                        border: 1px solid #D9D9D9;
                        border-right: none;
                        cursor: pointer;
                    }

                    .border-right {
                        border-right: 1px solid #D9D9D9;
                    }

                    .active-item {
                        border-top: 2px solid #2587FF;
                        background: #F4F7FF;
                        color: #2587FF;
                        height: 40px;
                        border-bottom: none;
                    }
                }

                .transport-wrapper{
                    height: 300px;
                    overflow-y: auto;
                    margin-top: 14px;
                }
            }

        }

        .info-box{
            ::v-deep .el-form-item--small.el-form-item {
                margin-bottom: 10px;
            }
        }

        .red-c{
            color: #EF4C56;
        }

        .distribution {
             ::v-deep .el-input {
                width: 300px;
            }
            ::v-deep .el-form-item--small.el-form-item{
                margin-bottom: 10px;
            }
        }
    }

</style>